// export default [
//   { name: "Subhash Nagar", position: 0 },
//   { name: "Tagore Garden", position: 0.85 },
//   { name: "Rajouri Garden", position: 1.95 },
//   { name: "Ramesh Nagar", position: 2.95 },
//   { name: "Moti Nagar", position: 4.15 },
//   { name: "Kirti Nagar", position: 4.95 },
//   { name: "Shadipur", position: 5.75 },
//   { name: "Patel Nagar", position: 6.85 },
//   { name: "Rajendra Place", position: 8.05 },
//   { name: "Karol Bagh", position: 9.05 },
//   { name: "Jhandewalan", position: 10.15 },
//   { name: "Ramakrishna Ashram Marg", position: 11.15 },
//   { name: "Rajiv Chowk", position: 12.55 }
// ];

export default [
  { name: "Dwarka Sector 21", position: 0 },
  { name: "Dwarka Sector 8", position: 2.0 },
  { name: "Dwarka Sector 9", position: 2.65 },
  { name: "Dwarka Sector 10", position: 4.65 },
  { name: "Dwarka Sector 11", position: 5.85 },
  { name: "Dwarka Sector 12", position: 7.55 },
  { name: "Dwarka Sector 13", position: 8.75 },
  { name: "Dwarka Sector 14", position: 10.55 },
  { name: "Dwarka", position: 12.45 },
  { name: "Dwarka Mor", position: 13.75 },
  { name: "Nawada", position: 15.75 },
  { name: "Uttam Nagar West", position: 17.35 },
  { name: "Uttam Nagar East", position: 18.35 },
  { name: "Janakpuri West", position: 20.55 },
  { name: "Janakpuri East", position: 22.15 },
  { name: "Tilak Nagar", position: 24.15 },
  { name: "Subhash Nagar", position: 26.0 },
  { name: "Tagore Garden", position: 26.85 },
  { name: "Rajouri Garden", position: 27.95 },
  { name: "Ramesh Nagar", position: 28.95 },
  { name: "Moti Nagar", position: 30.15 },
  { name: "Kirti Nagar", position: 30.95 },
  { name: "Shadipur", position: 31.75 },
  { name: "Patel Nagar", position: 32.85 },
  { name: "Rajendra Place", position: 34.05 },
  { name: "Karol Bagh", position: 35.05 },
  { name: "Jhandewalan", position: 36.15 },
  { name: "Ramakrishna Ashram Marg", position: 37.15 },
  { name: "Rajiv Chowk", position: 38.55 },
  { name: "Barakhamba Road", position: 39.05 },
  { name: "Mandi House", position: 40.25 },
  { name: "Pragati Maidan", position: 41.15 },
  { name: "Indraprastha", position: 44.35 },
  { name: "Yamuna Bank", position: 51.75 },
  { name: "Laxmi Nagar", position: 55.95 },
  { name: "Nirman Vihar", position: 57.15 },
  { name: "Preet Vihar", position: 58.15 },
  { name: "Karkarduma", position: 59.85 },
  { name: "Anand Vihar ISBT", position: 64.35 },
  { name: "Kaushambi", position: 66.95 },
  { name: "Vaishali", position: 69.25 }
];
